/*eslint-disable*/
import React from "react";
import { DatePicker } from "@mui/x-date-pickers-pro";
import { AdapterDateFns } from "@mui/x-date-pickers-pro/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers-pro/LocalizationProvider";
import { TextField } from "@mui/material";

const EditableDatePicker: React.FC<{
    label: string;
    value?: string; // Assuming stored as ISO string (e.g., "2025-03-16")
    isEditing?: boolean;
    fontSize?: string;
    onChange?: (date: string | null) => void;
}> = ({ label, value, fontSize = "16px", onChange, isEditing = true }) => {
    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
                label={label}
                value={value ? new Date(value) : null}
                onChange={(date) =>
                    onChange?.(date ? date.toISOString().split("T")[0] : null)
                }
                disabled={!isEditing} // Disable the DatePicker if isEditing is false
                slotProps={{
                    textField: {
                        variant: "standard", // Removes border
                        // InputProps: {
                        //     disableUnderline: true, // Removes underline
                        // },
                        sx: {
                            fontSize, // Custom font size
                            input: {
                                color: isEditing
                                    ? "black !important"
                                    : "black !important",
                                fontSize, // Apply font size to input
                                padding: "0px 0px", // Adjust padding inside the input field
                            },
                            "& .MuiInputBase-input.Mui-disabled": {
                                WebkitTextFillColor: isEditing
                                    ? "black !important"
                                    : "black !important",
                                fontSize, // Apply font size to input when disabled
                                padding: "0px 0px", // Adjust padding inside the input field
                            },
                            "& .MuiInput-underline:before": {
                                borderBottom: isEditing
                                    ? "1px solid #D1D5DB !important"
                                    : "none !important",
                            },
                            "& .MuiInput-underline:after": {
                                borderBottom: isEditing
                                    ? "1px solid #D1D5DB !important"
                                    : "none !important",
                            },
                        },
                    },
                }}
            />
        </LocalizationProvider>
    );
};

export default EditableDatePicker;
